import React, { lazy, Suspense, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Layout, LoadingLayout, Loading } from 'common/components/layout';
import { getCartTitle } from 'common/helpers/miscHelpers';
import { retry } from 'common/helpers/routerHelper';
import { getCart } from 'redux/cart/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

const LoadableComponent = lazy(() => retry(() => import('./App')));

const AppLoader = () => {
  const dispatch = useDispatch();
  const { t } = useLocalization();
  const cartReducer = useSelector((state) => state.cart);
  const settings = useSelector((state) => state.setting.data);

  useEffect(() => {
    dispatch(getCart());
  }, [dispatch]);

  if (!cartReducer.data) {
    return <LoadingLayout />;
  }

  return (
    <Layout title={getCartTitle(settings, t)}>
      <Suspense fallback={<Loading />}>
        <LoadableComponent />
      </Suspense>
    </Layout>
  );
};

export default AppLoader;
